import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {BusinessUnitModel, ProjectModel} from '../../../@models';
import {ApiService} from '../../../@core/service/api.service';
import {NbToastrService} from '@nebular/theme';

@Component({
  selector: 'ngx-form-list-business-unit',
  templateUrl: './form-list-business-unit.component.html',
  styleUrls: ['./form-list-business-unit.component.scss'],
})
export class FormListBusinessUnitComponent implements OnInit, OnChanges {
  @Input() businessUnits: BusinessUnitModel[];
  @Output() businessUnitsChange: EventEmitter<BusinessUnitModel[]> = new EventEmitter<BusinessUnitModel[]>();
  @Output() onSave: EventEmitter<BusinessUnitModel> = new EventEmitter();

  businessUnitsColumns = {
    name: {
      title: 'Name',
      type: 'text',
      filter: false,
    },
    description: {
      title: 'Description',
      type: 'text',
      editor: {
        type: 'textarea',
      },
      filter: false,
    },
    sort: {
      title: 'Sort',
      type: 'text',
      filter: false,
    },
    code: {
      title: 'Code',
      type: 'text',
      filter: false,
    },
  };

  private archive: BusinessUnitModel;

  constructor(private toastrService: NbToastrService) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.businessUnits != null)
      this.archive = this.businessUnits.find(x => x.name === 'General');
  }
  change(event) {
    this.businessUnitsChange.emit(event);
  }

  validate(event) {

    if (event.newData.name === '') {
      event.confirm.reject('Name is required');
      this.toastrService.danger('Name is required', 'Error');
    } else if (event.newData._id === this.archive._id) {
      event.confirm.reject('General can not be changed');
      this.toastrService.danger('General can not be changed', 'Error');
    } else {
      this.onSave.emit(event.newData);
      event.confirm.resolve();
    }
  }

}
